import {
  IconLayoutDashboard,
  IconNotification,
  IconPalette,
  IconReport,
  IconSettings,
  IconTool,
  IconUserCog,
  IconUserShield,
} from "@tabler/icons-react";
import { BugIcon, ClipboardCheck, ScrollText, Search } from "lucide-react";
import { type SidebarData } from "../types";

export const iuqSidebarData: SidebarData = {
  user: {
    name: "admin",
    email: "admindev@cao.ac.za",
    avatar: "/avatars/shadcn.jpg",
  },

  navGroups: [
    {
      title: "General",
      items: [
        {
          title: "Home",
          url: "/",
          icon: IconLayoutDashboard,
        },
      ],
    },
    {
      title: "Applicant Search",
      items: [
        {
          title: "Basic",
          icon: Search,
          items: [
            {
              title: "CAO number",
              url: "/search/basic/cao",
            },
            {
              title: "Personal Details",
              url: "/search/basic/personal",
            },
            {
              title: "Programme Choices",
              url: "/search/basic/qualification",
            },
          ],
        },
        {
          title: "Advanced",
          icon: Search,
          items: [
            {
              title: "Programme Choice",
              url: "/search/advanced/programme-choice",
            },
            {
              title: "General Choice",
              url: "/search/advanced/general",
            },
            {
              title: "Demographic",
              url: "/search/advanced/demographic",
            },
            {
              title: "Academic",
              url: "/search/advanced/academic",
            },
            {
              title: "Regretted Applicants",
              url: "/search/advanced/regretted-applicants",
            },
            {
              title: "Regretted Applicants (Ranking)",
              url: "/search/advanced/regretted-applicants-ranking",
            },
          ],
        },
        {
          title: "Web Walk-Ins",
          icon: Search,
          items: [
            {
              title: "CAO Number",
              url: "/search/web-walk-ins/cao",
            },
            {
              title: "Personal Details",
              url: "/search/web-walk-ins/personal",
            },
          ],
        },
      ],
    },
    {
      title: "Clearing House",
      items: [
        {
          title: "Search by Programme",
          icon: Search,
          url: "/clearing-house/search/programme",
        },
        {
          title: "Search by Academic Criteria",
          icon: Search,
          url: "/clearing-house/search/academic",
        },
      ],
    },
    {
      title: "Maintenance",
      items: [
        {
          title: "Walk-in Maintenance",
          icon: ClipboardCheck,
          url: "/maintenance/walk-in",
        },
      ],
    },

    {
      title: "Reports",
      items: [
        {
          title: "Check Results",
          icon: ScrollText,
          url: "/reports/check-results",
        },
        {
          title: "Reports",
          icon: IconReport,
          items: [
            {
              title: "Applicant Totals",
              url: "/reports/applicant-totals",
            },
            {
              title: "Applicants per Qualifications",
              url: "/reports/application-per-qualification",
            },
            {
              title: "Applicants Statistics (Gender, Population, Language)",
              url: "/reports/applicants-statistics/gender-pop-lang",
            },
            {
              title: "Applicants Statistics (Gender, Population, Age)",
              url: "/reports/applicants-statistics/gender-pop-age",
            },
            {
              title: "Applicant Statistics per Institution",
              url: "/reports/applicant-statistics-per-institution",
            },
            {
              title: "Applicant Geographic Statistics",
              url: "/reports/applicant-geographic-statistics",
            },
            {
              title: "Applicant / Application Statistics",
              url: "/reports/application-statistics",
            },
            {
              title: "Applicant Summary",
              url: "/reports/applicant-summary",
            },
            {
              title: "Institutions Statistics",
              url: "/reports/institutions-statistics",
            },
            {
              title: "Application Listing",
              url: "/reports/application-listing",
            },
            {
              title: "School Statistics",
              url: "/reports/school-statistics",
            },
          ],
        },
      ],
    },

    {
      title: "Processing",
      items: [
        {
          title: "IU Downloads",
          icon: ScrollText,
          url: "/processing/downloads",
        },
      ],
    },

    {
      title: "Other",
      items: [
        {
          title: "Settings",
          icon: IconSettings,
          items: [
            {
              title: "Profile",
              url: "/settings",
              icon: IconUserCog,
            },
            {
              title: "Change Password",
              url: "/settings/change-password",
              icon: IconUserShield,
            },
            {
              title: "Account",
              url: "/settings/account",
              icon: IconTool,
            },
            {
              title: "Appearance",
              url: "/settings/appearance",
              icon: IconPalette,
            },
            {
              title: "Notifications",
              url: "/settings/notifications",
              icon: IconNotification,
            },
          ],
        },
        {
          title: "Report an Error",
          url: "/report-error",
          icon: BugIcon,
        },
      ],
    },
  ],
};
